import React, { useEffect, useRef, useState } from "react";
import LogoLayout from "../../../components/logolayout/logolayout";
import SelectInput from "../../../components/form/inputs/select-input/select-input";
import TextInput from "../../../components/form/inputs/text-input/text-input";
import countriesJson from "../../../data/countries.json";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context/app.context";
import { emailReg, passwordReg, showToast } from "../../../utils/utils";
import CheckBoxInput from "../../../components/form/inputs/check-input/check-input";
import axiosInstance from "../../../config/axios";
import CodeInput from "../../../components/form/inputs/code-input/codeInput";
interface RegisterSignupPageProps {
  formData?: any;
  onNext?: (data: any) => void;
  onBack?: () => void;
}

export default function RegisterStep5Page({ formData, onNext, onBack }: RegisterSignupPageProps) {
  const [search, setSearch] = useState("");
  const [showmodal, setshowmodal] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [code, setcode] = useState("");
  const [resendCountdown, setResendCountdown] = useState(state?.duration);
  const disable = useRef(false);
  const passwordRules = [
    "More than 8 characters",
    "At least one uppercase and one lowercase letter",
    "Must contain a number or special character",
  ];
  // Countdown timer effect
  useEffect(() => {
    let timer: any;
    if (resendCountdown > 0) {
      timer = setInterval(() => {
        setResendCountdown((prev: any) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [resendCountdown]);
  useEffect(() => {
    setResendCountdown(state?.duration); // 60 seconds countdown
  }, []);

  const { appInfos, setAppInfos } = useAppContext();
  //   if (!state || (state && Object.keys(state).length == 0)) return <Navigate replace to="/register" />;
  function keepOnlyDigits(str: any) {
    return str.replace(/\D/g, "");
  }
  function hasSixDigits(str: any) {
    return !/^\d{6}$/.test(str?.trim()) ? "Code invalide" : true;
  }
  async function onResend() {
    if (resendCountdown > 0) return;
    try {
      if (disable.current) return;
      disable.current = true;
      await axiosInstance.post(`auth/signup`, {
        role: "provider",
        email: appInfos?.formState?.email,
        ...state,
      });
      showToast("Code envoyé !", "success");
      setResendCountdown(state?.duration);
    } catch (e) {
      showToast("Une erreur s'est produite");
    }
    disable.current = false;
  }
  async function onValidate(form: any) {
    try {
      const res = await axiosInstance.post(`auth/signup/verify`, {
        email: state.email,
        ...form,
        code,
      });
      navigate("/register/step3", {
        replace: true,
        state: {
          success: true,
          email: state?.email,
          signup_token: res.data.signup_token,
        },
      });
    } catch (e) {
      showToast("Code invalide");
    }
  }
  return (
    <LogoLayout
      renderAfterSubmit={() => (
        <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
          <span className="current ">{"Tu n’as pas reçu de code ?"}</span>
          <span
            onClick={onResend}
            style={{
              marginLeft: 4,
              fontWeight: 700,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            className={`current ${resendCountdown > 0 ? "disabled" : ""}`}
          >
            Renvoyer un code {resendCountdown > 0 && ` (${resendCountdown}s)`}
          </span>
        </div>
      )}
      onSubmit={onValidate}
      submitTitle="Valider"
      progress={45}
      hideBack={false}
    >
      <div className="d-flex flex-column flex-grow-1">
        <h4>Vérification de ton email</h4>
        <p className="current">Saisis le code à 6 chiffres envoyé à {state?.email}</p>
        <CodeInput
          length={6}
          onChange={(val: any) => {
            setcode(val);
          }}
        />
      </div>
    </LogoLayout>
  );
}
